import React from 'react';

interface RevealProps {
  children: React.ReactNode;
  /** unused - kept so existing call sites compile unchanged; see comment below */
  index?: number;
  as?: 'div' | 'section' | 'li' | 'figure';
  className?: string;
  id?: string;
}

/**
 * Used to fade every section up on scroll. The owner's brief called that
 * exact tell out ("fade-up on every section") as a template smell, so this
 * now just renders its children in the plain element, no animation at all.
 * The prop API (including the now-unused `index`) is kept so every call
 * site across the site keeps compiling with no changes.
 */
const Reveal: React.FC<RevealProps> = ({ children, as = 'div', className, id }) => {
  const Plain = as as React.ElementType;
  return (
    <Plain className={className} id={id}>
      {children}
    </Plain>
  );
};

export default Reveal;
